import actionTypes from 'app/actions/dictionaries/dictionaries.action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_INVOICE_DATES_DICTIONARY_SUCCESS: {
      return [ ...action.dates ];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/invoice-dates-dictionary.js